import api from '@pray/shared/utils/api';

import type { ReplaceContentMediaParams } from './types';

/**
 * Points the episode at an uploaded replacement file through the content PUT. The server swaps the
 * MediaMetadata row and clears what was derived from the old file. Studio admins only.
 */
export async function replaceContentMedia(artistId: string, contentId: string, params: ReplaceContentMediaParams) {
  const url = `/web/studio/artists/${artistId}/content/${contentId}`;

  const body: Record<string, string | number> = { [`${params.kind}_url`]: params.url };
  if (params.duration !== undefined) body[`${params.kind}_file_duration`] = params.duration;
  if (params.fileSize !== undefined) body[`${params.kind}_file_size`] = params.fileSize;

  await api.executePutRequest(url, body);

  return { success: true };
}
